import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radio from 'material-ui/Radio';
import { TableCell } from 'material-ui/Table';
import { fieldInputPropTypes } from 'redux-form';

import {
  coreToString,
  coreConstructionToStr
} from '../../../lib/material';
import { materialPropType } from '../../../lib/shapes';
import Core from '../../../models/Core';
import MaterialsTable from '../MaterialsTable';

export class CorePicker extends Component {
  constructor(props) {
    const selectedMaterialId = props.target.material.id.toString();
    super(props);

    this.state = { selectedMaterialId };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(id) {
    const { input, options } = this.props;
    const { onChange } = input;
    const selected = options.find(option => option.id.toString() === id);
    this.setState({ selectedMaterialId: id });

    onChange(selected);
  }

  render() {
    const { options, selected, target, lengthUnit } = this.props;
    const { selectedMaterialId } = this.state;

    const onChange = event => this.handleChange(event.target.value);
    const handleRowClick = (id) => this.handleChange(id);
    const selectedStr = selected ? coreToString(selected, lengthUnit) : target.toString(lengthUnit);
    const columns = [
      'construction',
      'thickness',
      'dkdf'
    ];

    return (
      <MaterialsTable
        materials={options}
        header={selectedStr}
        onRowClick={handleRowClick}
        shiftHeadCols={1}
        columns={columns}
        selectRender={material => {
          const id = material.id.toString();
          const construction = coreConstructionToStr(material)
          const checked = id === selectedMaterialId;

          return ( 
            <TableCell component="th" scope="row">
              <Radio
                checked={checked}
                onChange={onChange}
                value={id}
                name="material"
                aria-label={construction}
              />
            </TableCell>
          );
        }}
      />
    );
  }
}

CorePicker.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(materialPropType)).isRequired,
  target: PropTypes.instanceOf(Core).isRequired,
  selected: PropTypes.shape(materialPropType),
  lengthUnit: PropTypes.string.isRequired,
}

CorePicker.defaultProps = {
  selected: undefined,
}

export default (CorePicker);



// WEBPACK FOOTER //
// ./src/components/common/formComponents/CorePicker.js